import { PropsWithChildren } from 'react';

export const CalculatorModalLayout = ({ children }: PropsWithChildren) => (
    <div className="vss-calculator-modal-layout">
        {children}
    </div>
);
